export const overrides = theme => ({
  root: {
    minHeight: 160,
    padding: theme.spacing(3),
    [`${theme.breakpoints.down('xs')}`]: {
      padding: theme.spacing(2),
    },
  },
})
